import React from 'react';
import styled from 'styled-components';
import { LabelContainer } from './FoodDialog';
import formatPrice from '../../../../../utils/formatPrice';

const ChoiceGrid = styled.div`
    display: grid;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: #222c31;
    grid-template-columns: repeat(1, 1fr);
    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
`;

const ChoiceDiv = styled.div`
    margin-top: 20px;
`;

const CursorPointer = `cursor: pointer;`;

export const RadioInput = styled.input`
    ${CursorPointer}
    margin-right: 10px;
    border: 2px solid #36b37e;
    box-sizing: border-box;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    margin-top: 5px;
    vertical-align: middle;
    color: #222c31;
`;

export function Choices({ openFood, choiceRadio, setChoice }) {
    function radioOnChange(e) {
        setChoice(e.target.value);
    }

    var samePrice = true;
    for (var i = 1; i < openFood.choices.length; i++) {
        if (openFood.choices[i - 1].price !== openFood.choices[i].price) {
            samePrice = false;
        }
    }

    return (
        <ChoiceDiv>
            {openFood.choiceslabel ? (
                <LabelContainer>
                    <b>{openFood.choiceslabel}</b>
                </LabelContainer>
            ) : (
                <LabelContainer>
                    <b>Choose one:</b>
                </LabelContainer>
            )}
            <ChoiceGrid>
                {openFood.choices.map((choice) => (
                    <>
                        <label>
                            <RadioInput
                                type="radio"
                                id={choice.name}
                                name="choice"
                                value={choice.name}
                                checked={choiceRadio === choice.name}
                                onChange={radioOnChange}
                            />
                            {choice.name}
                            {choice.price && !samePrice && (
                                <span>
                                    {' '}
                                    ({formatPrice(choice.price / 100)})
                                </span>
                            )}
                            {openFood.uom !== 'people' && choice.serves && (
                                <span>
                                    {choice.serves.min === choice.serves.max
                                        ? choice.serves.min > 1
                                            ? ` (serves ${choice.serves.min} people)`
                                            : ''
                                        : ` (serves ${choice.serves.min} to ${choice.serves.max} people)`}
                                </span>
                            )}
                        </label>
                    </>
                ))}
            </ChoiceGrid>
        </ChoiceDiv>
    );
}
